module.exports = __webpack_public_path__ + "img/carousel-3.d8ba3a08.jpg";